// extracted by mini-css-extract-plugin
module.exports = {"container":"c7yDDlxSE7lBoRsWv-YEu content"};